import { render, staticRenderFns } from "./legs.vue?vue&type=template&id=5c1a5495&"
import script from "./legs.vue?vue&type=script&lang=js&"
export * from "./legs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports